"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Missioncalltoaction() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="234" id="missioncalltoaction" className="bg-background text-foreground relative overflow-hidden py-32 md:py-44 lg:py-[180px] px-6">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-1/3 -right-1/4 h-[900px] w-[900px] rounded-lg" style={{
      background: "radial-gradient(circle at center, hsla(118, 72%, 58%, 0.15) 0%, hsla(118, 72%, 58%, 0.05) 30%, hsla(118, 72%, 58%, 0) 65%)"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-10" style={{
      background: "radial-gradient(ellipse at top left, hsla(120, 38%, 14%, 0.6) 0%, hsla(120, 38%, 14%, 0) 60%)"
    }} />

      <div className="relative mx-auto max-w-[960px]">
        {}
        <div className="flex items-center justify-center gap-4 mb-10">
          <span className="h-px w-12 bg-primary/40" />
          <span className="font-default text-xs uppercase tracking-[0.25em] text-primary">
            Forever Fresh / Mission
          </span>
          <span className="h-px w-12 bg-primary/40" />
        </div>

        {}
        <div aria-hidden="true" className="absolute left-0 right-0 top-1/2 -translate-y-1/2 flex flex-col gap-3 opacity-20 pointer-events-none">
          <div className="h-px bg-foreground/40 -mx-[20vw]" />
          <div className="h-px bg-foreground/40 -mx-[20vw]" />
          <div className="h-px bg-foreground/40 -mx-[20vw]" />
          <div className="h-px bg-foreground/40 -mx-[20vw]" />
          <div className="h-px bg-foreground/40 -mx-[20vw]" />
        </div>

        {}
        <h2 ref={headlineRef} className="relative font-default font-light text-center leading-[0.95] tracking-tight text-foreground transition-all duration-1000 ease-out" style={{
        fontSize: "clamp(4rem, 9vw, 9rem)",
        opacity: headlineVisible ? 1 : 0,
        transform: headlineVisible ? "translateY(0)" : "translateY(40px)"
      }}>
          Support the{" "}
          <span className="italic font-normal text-primary">Cause</span>
          <span className="text-primary">.</span>
        </h2>

        {}
        <p className="relative mt-10 text-center text-foreground/80 max-w-2xl mx-auto transition-all duration-1000 delay-200 ease-out" style={{
        fontSize: "22px",
        lineHeight: "1.5",
        opacity: headlineVisible ? 1 : 0,
        transform: headlineVisible ? "translateY(0)" : "translateY(30px)"
      }}>
          Your contribution keeps awareness issues forever fresh. Join our community and make a tangible impact today.
        </p>

        {}
        <div ref={ctaRef} className="relative mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-300 ease-out" style={{
        opacity: ctaVisible ? 1 : 0,
        transform: ctaVisible ? "translateY(0)" : "translateY(30px)"
      }}>
          <Button asChild size="lg" className="h-14 px-8 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 text-base font-medium shadow-lg group">
            <Link to="/CurrentCausesPage">
              Explore Causes
              <ArrowRight className="ml-1 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="h-14 px-8 rounded-lg border border-foreground/40 bg-transparent text-foreground hover:bg-foreground/5 hover:text-foreground text-base font-medium group">
            <Link to="/ShopPage">
              Shop Current Drop
              <ArrowRight className="ml-1 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>

        {}
        <div className="relative mt-24 md:mt-32 flex items-center justify-center gap-4">
          <span className="h-px w-8 bg-foreground/20" />
          <p className="font-default text-xs uppercase tracking-[0.3em] text-foreground/60">
            Join the movement &bull; Together we grow
          </p>
          <span className="h-px w-8 bg-foreground/20" />
        </div>
      </div>
    </section>;
}